import React, { useEffect, useRef } from "react";

export function AiChatMessages({ messages, streaming }) {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, streaming]);

  return (
    <div className="mt-4 space-y-3 max-h-80 overflow-y-auto" data-testid="ai-chat-messages">
      {messages.map((m, i) => (
        <div
          key={`${m.role}-${i}`}
          className={`text-sm leading-relaxed rounded-lg px-4 py-2.5 ${
            m.role === "user"
              ? "bg-[#156F5B] text-white ml-auto max-w-[85%] w-fit"
              : "bg-[#F3F8F7] text-[#212121] max-w-[92%]"
          }`}
          data-testid={`ai-msg-${m.role}-${i}`}
        >
          {m.text || (streaming && i === messages.length - 1 ? "Thinking…" : "")}
        </div>
      ))}
      <div ref={endRef} />
    </div>
  );
}
